
import {Component, Prop, VModel, Vue} from "vue-property-decorator";
import Popup from "../Popup.vue";
// import Popup from '../Popup.vue';

@Component({
  components: {Popup}
})
export default class ListInput extends Vue {
  @VModel({})
  public modelValue!: object[];

  @Prop({})
  protected path!: string;

  @Prop({})
  protected properties!: { html: {}, readonly?: boolean, disabled?: boolean, options?: object };

  @Prop({})
  protected success!: object[];

  @Prop({})
  protected error!: object[];

  //local variables
  protected readonly: boolean = false;
  protected disabled: boolean = false;
  protected html: object = {};
  protected options?: {
    addFields?: number,
    editable?: boolean,
    delete?: boolean,
    title?: { max?: number, min?: number },
    value?: { max?: number, min?: number }
  } = {};
  public newListItemTitle: string = '';
  public newListItemValue: string = '';

  //error and success
  protected localSuccess: boolean = false;
  protected localError: boolean = false;
  protected localErrorMessages: string[] = [];

  //popup
  public showPopup: boolean = false;
  public popup: { color: string, code: number, message: string, timeout?: number };

  mounted() {
    if (this.properties.options) {
      this.options = this.properties.options;
    } else {
      this.options = {}
    }


    if (!this.options.addFields) {
      this.options.addFields = 0;     //default value if not set
    }


    if (!this.options.editable) {
      this.options.editable = false;     //default value if not set
    }

    if (!this.options.delete) {
      this.options.delete = false;     //default value if not set
    }


    if (this.properties.disabled) {
      this.disabled = this.properties.disabled;
    }

    if (this.properties.readonly) {
      this.readonly = this.properties.readonly
    }

    this.html = this.properties.html;

  }

  public removeListItem(index: number) {
    //remove item from arr
    this.modelValue.splice(index, 1);
  }

  public addListItem() {
    if (this.options) {
      if (this.options.title) {
        let max: number = 255;
        let min: number = 0;

        //kijk naar of er een max of min is ingesteld
        if (this.options.title.max) {
          max = this.options.title.max;
        }

        if (this.options.title.min) {
          min = this.options.title.min;

        }

        if (this.newListItemTitle.length < min || this.newListItemTitle.length > max) {
          this.popup = {
            color: 'error',
            code: 400,
            message: 'New item title is either not at least ' + min + ' characters. Or is longer then ' + max + ' characters',
          }
          this.showPopup = true;

          return; //show popup.

        }

        if (this.options.value) {
          let max: number = 255;
          let min: number = 0;

          //kijk naar of er een max of min is ingesteld
          if (this.options.value.max) {
            max = this.options.value.max;
          }

          if (this.options.value.min) {
            min = this.options.value.min;

          }

          if (this.newListItemValue.length < min || this.newListItemValue.length > max) {
            this.popup = {
              color: 'error',
              code: 400,
              message: 'New item value is either not at least ' + min + ' characters. Or is longer then ' + max + ' characters',
            }
            this.showPopup = true;
            return;
          }
        }
      }
    }

    //options duplicate key option?

    //check if already exists in list
    let inObject: boolean = false;

    this.modelValue.forEach((item, index) => {
      if (item.key === this.newListItemTitle) {
        inObject = true;
      }
    });


    if (inObject) {
      this.popup = {
        color: 'error',
        code: 400,
        message: 'Item already exists in list.',
      }
      this.showPopup = true;
      return;
    }


    // //check if item with title exists in arr
    // let doesTitleExist: boolean = false;
    //
    // // doesTitleExist = this.itemValue.forEach(e => e.some((item) => item.key === this.newListItemTitle))
    // this.itemValue.forEach((e) => {
    //     if (e.key === this.newListItemTitle) {
    //         return doesTitleExist = true;
    //     }
    // });
    //
    // if (doesTitleExist) {
    //     return alert(this.newListItemTitle.charAt(0).toUpperCase() + this.newListItemTitle.slice(1) + ' is already in the list. Give it another title')
    // }


    //create new item
    let listItemToAdd = {
      key: this.newListItemTitle,
      value: this.newListItemValue
    }
    //push the new object into array of objects
    this.modelValue.push(listItemToAdd)

    // console.log('added item to movel value')
    // console.log('item');
    // console.log(listItemToAdd);
    // console.log('list');
    // console.log(this.modelValue)


    //display addition message
  }

  /**
   * TODO:
   * List levels (hoeveel elementen kan je toevoegen? (alleen naam? of ook value))
   *  List laten werken op index EN key value
   *  List popup veranderen naar snackbar. (emit event-?)
   */
}
